import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classlist from 'utils/classlist';
import './style.scss';

export interface IUploaderProps {
    type: string; // 'wrong_birth' | 'wrong_residence' | 'wrong_ssn';
}

export const UploaderState: any = {};

const proofsConfig = {
    wrong_birth: {
        title: __('Proof of ID')
    },
    wrong_residence: {
        title: __('Proof of Address')
    },
    wrong_ssn: {
        title: __('Proof of SSN')
    }
};

class Uploader extends Component<IUploaderProps> {
    public render() {
        const { type } = this.props;
        const config = proofsConfig[type];
        const hasUpload = !!UploaderState[type];

        return (
            <div className={classlist('uploader-component-root', `uploader-compoennt-${type}`)}>
                <div className={classlist('proof-icon', `proof-icon-${type}`)} />
                <div className="title">
                    <h4>{config.title}</h4>
                    {hasUpload && <Badge bg="warning">{__('Uploaded')}</Badge>}
                </div>
                <Link to={`/proof/${type}`} className="upload">
                    <div className="upload-icon"></div>
                    <span>{hasUpload ? __('Reupload') : __('Upload')}</span>
                </Link>
            </div>
        );
    }
}

export default Uploader;
export { default as FileInput } from './FileInput';
export * from './type';
